import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRetrieveSearchActions from '../+state/actions/retrieve-search.actions';
import {
  RetrieveSearchMcResponse,
  RetrieveSearchOwRtResponse
} from '../models/core-apis/retrieve-search.interfaces';

@Injectable({ providedIn: 'root' })
export class RetrieveSearchFacade {
  constructor(private store: Store) {}

  storeInputValues(
    triggerRetrieveSearchLanding: boolean,
    retrieveSearchMcCacheKey: string,
    retrieveSearchOwRtResponse: RetrieveSearchOwRtResponse[] | null,
    retrieveSearchMcResponse: RetrieveSearchMcResponse | null
  ) {
    this.store.dispatch(
      fromRetrieveSearchActions.StoreRetrieveSearchInputValues({
        triggerRetrieveSearchLanding,
        retrieveSearchMcCacheKey,
        retrieveSearchOwRtResponse,
        retrieveSearchMcResponse
      })
    );
  }

  loadRetrieveSearch() {
    this.store.dispatch(fromRetrieveSearchActions.LoadRetrieveSearch());
  }
}
